export const isActiveLessonPack = ({ remainingCredits, expiresAt }) =>
  remainingCredits > 0 &&
  (expiresAt === null ||
    expiresAt === undefined ||
    Date.parse(expiresAt) > Date.now())

export const canBuildLessonPackBookingUrls = lessonType => {
  const locationId = lessonType?.locations?.[0]?.id
  const bookingUrl = lessonType?.coach?.bookingUrl
  const lessonTypeId = lessonType?.id

  if (!locationId || !bookingUrl || !lessonTypeId) {
    return false
  }

  return Boolean(bookingUrl.match(/\/coach\/([^/?]+)/)?.[1])
}

export const buildLessonPackBookingUrls = (lessonType, remainingCredits) => {
  if (!canBuildLessonPackBookingUrls(lessonType)) {
    return null
  }

  const { coach, locations, id } = lessonType
  const locationId = locations[0].id
  const coachSlug = coach.bookingUrl.match(/\/coach\/([^/?]+)/)?.[1]
  const relativeBookingUrl =
    `/coach/${coachSlug}/schedule` +
    `?lessonTypeId=${id}&locationId=${locationId}`

  return {
    buyMoreVouchersUrl: `${relativeBookingUrl}&isLessonPacks=true`,
    bookSessionUrl: `${relativeBookingUrl}&lessonCreditBalanceQuantity=${remainingCredits}`,
  }
}

export const getLessonPackActionVisibility = ({
  lessonType,
  totalCredits,
  remainingCredits,
  isUsedOrExpired,
}) => {
  const { deletedAt, status, giftingEnabled } = lessonType || {}
  const isGiftable =
    giftingEnabled && Number(totalCredits) === Number(remainingCredits)
  const canBook = canBuildLessonPackBookingUrls(lessonType)

  return {
    isGiftable,
    showBook: canBook && !isUsedOrExpired && remainingCredits > 0,
    showBuyAnother: canBook && !deletedAt && status !== 'INACTIVE',
    showGift: !isUsedOrExpired && isGiftable,
  }
}

export const getLessonPackStatusLabel = ({
  remainingCredits,
  expiresAt,
  isUsedOrExpired = false,
}) => {
  if (remainingCredits === 0) {
    return 'Used'
  }

  const isExpired =
    isUsedOrExpired || (expiresAt && Date.parse(expiresAt) < Date.now())

  if (isExpired) {
    return 'Expired'
  }

  return 'Active'
}
